import React from 'react';
import './styles.scss';
import { Popup } from 'semantic-ui-react';

// import { ReactComponent as BriefcaseIcon } from '~/assets/company-badges/briefcase-fill.svg';
import { ReactComponent as PenIcon } from '~/assets/company-badges/pen-fill.svg';
import { ReactComponent as DoorIcon } from '~/assets/company-badges/door-open-fill.svg';
import { ReactComponent as StopwatchIcon } from '~/assets/company-badges/stopwatch-fill.svg';
import { ReactComponent as CashIcon } from '~/assets/company-badges/cash-stack.svg';
// import { ReactComponent as MegaphoneIcon } from '~/assets/company-badges/megaphone-fill.svg';
import { ReactComponent as PersonIcon } from '~/assets/company-badges/person-fill-add.svg';
import { ReactComponent as BankIcon } from '~/assets/company-badges/bank2.svg';
import { ReactComponent as PiggyBankIcon } from '~/assets/company-badges/piggy-bank-fill.svg';
import { ReactComponent as ToolsIcon } from '~/assets/company-badges/tools.svg';
import { ReactComponent as ConeIcon } from '~/assets/company-badges/cone-striped.svg';



type CompanyBadgeProps = {
    badge: any;
};

const CompanyBadge: React.FC<CompanyBadgeProps> = ({ badge }) => {

    const popupPosition =
        badge.icon === 'notInterested' || badge.icon === 'interested' || badge.icon === 'matched'
            ? 'top right'
            : 'top left';

    return (
        <Popup position={popupPosition} header={badge.name} content={badge.description} trigger={
            <div className={`company-badge ${badge.icon}`}>
                {(() => {
                    switch (badge.icon) {
                        case 'is-also-an-epc':
                            return <ToolsIcon />;
                        case 'access-to-decision-makers':
                            return <DoorIcon />;
                        case 'quick-to-close':
                            return <PenIcon />;
                        case 'internal-te':
                            return <CashIcon />;
                        case 'quick-to-bid':
                            return <StopwatchIcon />;
                        case 'will-do-co-dev':
                            return <PersonIcon />;
                        case 'institutional':
                            return <BankIcon />;
                        case 'sub-ig-credit':
                            return <PiggyBankIcon />;
                        case 'has-safe-harbor-equipment':
                            return <ConeIcon />;
                        default:
                            return null;
                    }
                })()}
            </div>
        } />

    );
};

export default CompanyBadge;